/**
 * Copyright 2016 xdot GmbH
 *
 * Author: Carsten Hibbeler
 * Date: 28.01.2016
 *
 */

import FluxReduceStore from 'flux/lib/FluxReduceStore';

//TODO Unused test -> delete if not useful
export default class KeyStateStore extends FluxReduceStore {

    getKeyFromAction(action) {
        //implement
    }

    getReducer(state, action) {
        //implement
    }

    subStateSet(state, key, subState) {
        const newState = {
            ...state
        };
        if (!subState) {
            delete newState.stateByKey[ key ];
        } else {
            newState.stateByKey[ key ] = subState;
        }
        return newState;
    }

    getStateByKey(key) {
        return this.getState().stateByKey[ key ];
    }

    getInitialState() {
        return {
            stateByKey: {}
        };
    }

    reduce(state, action) {
        const reducer = this.getReducer(action);

        if (reducer) {
            const key = this.getKeyFromAction(action);
            if (key) {
                const subState = state[ key ],
                    newSubState = reducer(subState, action);

                if (subState !== newSubState) {
                    state = this.subStateSet(state, key, newSubState);
                }
            } else {
                console.warn('Invalid state key for ', action);
            }
        }

        return state;
    }


}




// WEBPACK FOOTER //
// ./js/stores/KeyStateStore.js